(function() {
    'use strict';

    angular
        .module('auth')
        .controller('LogoutController', LogoutController);

    LogoutController.$inject = ['AuthService', '$state'];

    /* @ngInject */
    function LogoutController(AuthService, $state) {
        var vm = this;

        activate();

        function activate() {
            vm.user = AuthService.getCurrentUser();
            AuthService.logout();
        }
    }
})();